import kotlinx.browser.window
import org.w3c.dom.PopStateEvent
import org.w3c.dom.events.Event

actual fun runJsOnpopstate() {
    window.onpopstate = {
        window.dispatchEvent(Event("compose-popstate"))
    }
}

actual fun runJsAddPopStateListener(listener: (Any) -> Unit) {
    window.addEventListener("compose-popstate", listener, window.history.state.asDynamic())
}

actual fun runJsRemovePopStateListener(listener: (Any) -> Unit) {
    window.removeEventListener("compose-popstate", listener, window.history.state.asDynamic())
}

actual fun runJsPushState(route: String) {
    val state = js("{ route: route }")
    window.history.pushState(state, "", route)
}

actual fun runJsBack() {
    window.history.back()
}

actual fun popBackWeb(onNavigateWeb: (String) -> Unit, onPopBackStack: () -> Unit) {
    val state = window.history.state.asDynamic()
    val route = state?.unsafeCast<dynamic>()?.route as? String
    println("App Navigating to $route, state: $state")

    if (state != null && route != null) {
        onNavigateWeb(route)
    } else {
        onPopBackStack()
    }
}